import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'react-query/constant';
import { getDoctorInfo } from 'modules/user/services/doctor-info-service';

export const useDoctorInfo = () => {
  return useQuery([queryKeys.doctorInfo], getDoctorInfo, {
    staleTime: 5 * 60 * 1000, // 5min
    cacheTime: 10 * 60 * 1000, // 10min
    refetchOnWindowFocus: false,
    onError: (error) => {
      console.log(error);
    }
  });
};
